const forms = {
  onRequest: "On Request",
  person: "person",
  travelDate: "Travel Date",
  travelDates: "Travel Dates",
  cancel: "Cancel",
  getPrice: "Get Price",
};

export default forms;
